import Loading from 'vue-loading-overlay';
import { mapGetters, mapMutations } from 'vuex';
import { orderService } from '../../services/OrderService'
import FileUpload from 'vue-upload-component'
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker';
import VueNumeric from 'vue-numeric'
import Vue from 'vue'
import { required, minLength, between } from 'vuelidate/lib/validators';
import store from '../../vuex/index'
import { EventBus } from '@/event-bus';

export default {
    name: 'EditPaymentComponent',

    components: {
        Loading,
        FileUpload,
        Multiselect,
        Datepicker,
        VueNumeric
    },

    props:
    {
        order: {},
        payment: {
            type: Object,
            default: null
        }
    },

    data: () => {
        return {
            loading: true,
            //
            authHeaders: {},
            postUrl: '/api/Attachment/postFiles',
            //
            paymentFiles: [],
            //
            paymentUploadParams: {
                targetType: 1, // Payment
                targetId: 0
            },
            //
            paymentUploaded: false,
            //
            itemToBeDeleted: null,
            //
            showPreview: false,
            previewLink: '',

            //
            savePaymentInfo: {
                Id: '',
                OrderId: 0,
                DueAmount:0,
                Paid: false,
                PaidDate: null,
                PaidAmount: 0,
                ReceipeNo: '',
                SendEmailToUser: false,
                SendEmailToClient: false,
                RowVersion: '',
            },
        }
    },
    validations() {
         {
            return {
                savePaymentInfo: {
                    PaidAmount: {
                        required,
                        between: between(0.001, 100000000)
                    },
                    DueAmount: {
                        required,
                        between: between(0.001, 100000000)
                    },
                    PaidDate: {
                        required
                    },
                },
            }
        }
        
    },

    computed: {
        isValid() {
            return !this.$v.$anyError
        },

        paidAmountIsInvalid() {
            return this.$v.savePaymentInfo.PaidAmount.$anyError;
        },
        dueAmountIsInvalid() {
            return this.$v.savePaymentInfo.DueAmount.$anyError;
        },
    },

    created() {

        this.loadFromPayment();

        // Add the auth header manually here as the post will not be done through axios (so it's not added automatically)
        const authToken = store.getters['auth/authToken'];
        if (authToken) {
            this.authHeaders.Authorization = `Bearer ${authToken}`;
        }

        //
        this.paymentFiles = [];

        //
        this.loading = false;
    },

    methods: {
        chkState: function (val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid
        },

        validate: function () {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            return this.isValid;
        },

        //

        checkPaidChange(checked) {
            if (checked) {
                this.savePaymentInfo.PaidAmount = this.savePaymentInfo.DueAmount;
            }
            else {
                this.savePaymentInfo.PaidAmount = 0;
            }
        },

        //

        saveAttachment: function () {
            var model = this;

            if (model.paymentFiles.length == 0) {
                // Change the bound value
                this.$emit('input', { paymentFinalized: true });
            } else {
                // Payment: Update the 'data' (POST params) to be sent to the back-end when uploading new files
                model.paymentFiles.forEach(function (value, key) {
                    if (value.isNew) {
                        model.paymentUploadParams.targetId = model.savePaymentInfo.Id;

                        Vue.set(value, 'data', model.paymentUploadParams)

                        // Trigger the file upload
                        model.$refs.uploadPayment.active = true;

                        // The .files watcher is detecting more changes.
                        // We need to react only after the saving is done.
                        model.paymentUploaded = true;
                    }
                });
            }
        },

        viewAttachment: function (dataItem) {
            if (dataItem != null) {
                var model = this;

                if (dataItem.isNew) {
                    model.showPreview = true;
                    model.previewLink = dataItem.blob;
                }
            }
        },

        setItemToBeDeleted(targetType, data) {
            if (data != null) {
                this.itemToBeDeleted = {
                    'item': data,
                    'targetType': targetType
                };
                //
                this.$refs['modalConfirmDeleteAttach'].show();
            }
        },

        deleteAttachment: function (itemToBeDeleted) {
            if (itemToBeDeleted != null) {
                var model = this;

                if (itemToBeDeleted.targetType == 1) {
                    //
                    // Payment
                    //
                    if (itemToBeDeleted.item.isNew) {
                        model.$refs.uploadPayment.remove(itemToBeDeleted.item);
                    }
                    else {
                        var attachPromise = attachmentService.deleteAttachment(itemToBeDeleted.item.id)
                            .then(response => {
                                model.$refs.uploadPayment.remove(itemToBeDeleted.item);
                            })

                        axios.all([attachPromise])
                            .then(axios.spread(function () {
                                model.loading = false;
                            }));
                    }
                }
            }
        },

        inputFile: function (newFile, oldFile) {
            if (newFile && newFile.isNew == undefined)
                newFile.isNew = true;

            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                console.log('response', newFile.response)
                if (newFile.xhr) {
                    //  Get the response status code
                    console.log('status', newFile.xhr.status)
                }
            }
        },

        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpg|gif|png|webp|pdf|zip|rar|doc|docx|xls|xlsx)$/i.test(newFile.name)) {
                    return prevent()
                }
            }

            if (newFile) {
                // Create a blob field
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                }
            }
        },

        getDownloadLink: function (data) {
            if (data.item.url) {
                return data.item.url;
            }
            else {
                return 'api/Attachment/' + data.item.id;
            }
        },

        //
        savePayment: function () {
            if (!this.validate())
                return;

            var model = this;
            model.loading = true;

            orderService.savePayment(this.savePaymentInfo).then(() => {
                // Upload docs
                model.saveAttachment();
                EventBus.$emit('paymenFiles_uploaded', this.order.Id);
            });
        },

        loadFromPayment: function () {

            // update payment
            this.savePaymentInfo.Id = this.payment.Id;

            this.savePaymentInfo.DueDate = this.payment.DueDate;
            this.savePaymentInfo.DueAmount = this.payment.DueAmount;

            this.savePaymentInfo.Paid = this.payment.Paid;
            this.savePaymentInfo.ReceipeNo = this.payment.ReceipeNo;
            this.savePaymentInfo.PaidAmount = this.payment.PaidAmount;
            this.savePaymentInfo.OrderId = this.order.Id;

            if (!this.payment.Paid) {
                var date = new Date();
                this.savePaymentInfo.PaidDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            }
            else {
                this.savePaymentInfo.PaidDate = this.payment.PaidDate;
            }

            // row version
            this.savePaymentInfo.RowVersion = this.order.RowVersion;
        },
    },

    watch: {
        paymentFiles: {
            handler: function () {
                var paymentUploadDone = this.$refs.uploadPayment.uploaded && this.paymentUploaded;

                if (paymentUploadDone) {
                    this.loading = false;

                    // Change the bound value
                    this.$emit('input', { uploadFinalized: true });
                    
                    
                }
            },
            deep: true
        },
    }
}
